/* eslint-disable no-nested-ternary */
import { Img } from "../layout/Img"

export const PageHeader = ({
  title,
  pageHeaderTitle,
  pageHeaderText,
  pageHeaderImage,
  flipMask,
  caseStudy,
  noMask,
}) => {
  const [coverPicture] = pageHeaderImage

  return (
    <header>
      <div
        className={`container px-4 py-10 mx-auto sm:px-10 md:w-full md:py-24 lg:w-8/12 ${
          caseStudy ? "md:pb-10 md:pt-24" : "md:py-24"
        }`}
      >
        <span className="text-base uppercase text-primary">
          {pageHeaderTitle || title}
        </span>
        <h1 className="mt-3 mb-4 text-4xl font-semibold leading-none text-secondary sm:text-4xl md:text-6xl">
          {pageHeaderText}
        </h1>
      </div>

      {coverPicture && (
        <div className="mx-auto 2xl:container">
          <div
            className={`relative ${
              caseStudy || noMask?.length
                ? ""
                : flipMask
                ? "masked-image--flipped"
                : "masked-image"
            }`}
          >
            <Img
              image={coverPicture}
              className={`${caseStudy ? "rounded" : ""}  h-64 md:h-[550px]`}
            />
          </div>
        </div>
      )}
    </header>
  )
}
